<header
  [returnPath]="returnPath"
  [showLogo]="true"
  [menuConfig]="landingPageMenuConfig.LANDING_PAGE_MENU_CONFIG"
  [sticky]="appHeaderSticky()"
  [transition]="true"
></header>
<pm-pages-slider
  [pages]="[s1, s2, s3, s5]"
  (pageScroll)="onPageScroll($event)"
></pm-pages-slider>
<ng-template #s1 let-item>
  <section-1 />
</ng-template>
<ng-template #s2 let-item>
  <section-2 />
</ng-template>
<ng-template #s3 let-item>
  <section-3 />
</ng-template>
<ng-template #s5 let-item>
  <section-5 />
</ng-template>

@if (emojiActions) {
  <div class="hide-on-portrait cookies-settings-floating-button">
    @for (emojiAction of emojiActions; track emojiAction) {
      <pm-emoji [emoji]="emojiAction.icon" (click)="emojiAction!.action()!" />
    }
  </div>
}
